import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import * as userReducer from '../../reducers/userReducer';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import { BODY_TEXT_COLOR } from '../../config/colors';
import { rootPageUri } from '../../config/uri';
import {
  howDidYouHear,
  startRequestCode,
} from '../../actions/signup-sync';
import { push } from 'connected-react-router';
import { CloseIcon } from '../../icons';
import {
  getReasonsSelector,
  isEmailVerificationRequired,
} from '../../selectors/configSelectors';
import { pushWithQueryParams } from '../../services/uri';

import './style.css'

const focusUsernameInputField = input => {
  input && input.focus();
};

const styles = {
  customWidth: {
    width: 150,
  },
};

class HowDidYouHearModal extends Component {
   styles = {
      closeBtn: { position: 'absolute',  right: '10px', top: '10px', cursor: 'pointer' },
      closeIcon: { height: '35px',  width: '35px' },
      modal: {padding: '20px', overflow: 'hidden'},
      greetings: {
        textAlign:'center',
        fontWeight: 700
      },
      field: {
        textAlign:'center',
        margin: '12px 0 20px',
        display: 'flex',
        flexDirection: 'column',
      },
      labelStyle: {fontWeight:700}
    };
    state = {
        isOpen: true,
        value: '',
    }
    onCloseRequest = () => {
        this.setState({
            isOpen: false
        })
        // if (!this.isSignupRequest) {
        //   this.props.hideModal();
        // }
    }

    handleNextClick = () => {
      const howDidYouHear = this.state.other ? this.state.other : this.state.value;
      this.props.howDidYouHear(howDidYouHear);

      if (this.props.isEmailVerification) {
        this.props.openSignUpConfirm();
      } else {
        this.props.requestCode();
      }
    }

  handleInput = (e) => {
    this.setState({
      other: e.target.value
    })
  }

  handleExit = () => {
    this.props.hideModal();
    this.props.openMainPage();
  }

  handleChange = (event, index, value) => {
    this.setState({value, other: ''});
  }
  render() {
    const menuItems = this.props.reasons.map((reason, idx) => <MenuItem key={idx} selectedTextColor="black" value={reason} primaryText={reason} />);
    return (
      <Modal wrapperTop={'250px'} overlayTop={0} closeOnOverlayClick={false} closeOnOutsideClick={false} isOpened={this.state.isOpen} onClose={this.onCloseRequest}>
          <div className="how-did-you-hear">
            <div style={this.styles.closeBtn} onClick={this.handleExit}>
              <CloseIcon color="#afafb1" style={this.styles.closeIcon} />
            </div>
            <div style={this.styles.greetings}>
              <HeaderDiv color={BODY_TEXT_COLOR}>
                <div>HOW DID YOU HEAR ABOUT US?</div>
              </HeaderDiv>
            </div>

            <div style={this.styles.field}>
              <SelectField
                floatingLabelText="Select source"
                value={this.state.value}
                onChange={this.handleChange}
                inputStyle={{ color: BODY_TEXT_COLOR }}
                style={{padding: 0, fontSize: '18px', fontWeight:'700', color: BODY_TEXT_COLOR }}
                floatingLabelStyle={{color: '#'+this.props.primaryColor, padding: 0, left: 0}}
                floatingLabelFocusStyle={{color: '#'+this.props.primaryColor, left: 0}}
                underlineStyle={{borderColor: BODY_TEXT_COLOR, }}
                underlineFocusStyle={{ borderColor: '#'+this.props.secondaryColor}}
                labelStyle={{ color: BODY_TEXT_COLOR, padding: 0 }} 
                selectedMenuItemStyle={{color: '#'+this.props.secondaryColor}}
              >
                {menuItems}
              </SelectField>
              { this.state.value === 'Other' && <TextField
                  type="text"
                  maxLength="60"
                  onChange={this.handleInput}
                  name="howdidyouhear"
                  ref={focusUsernameInputField}
                  inputStyle={{ color: BODY_TEXT_COLOR }}
                  style={{fontSize: '18px', fontWeight:'700', color: BODY_TEXT_COLOR }}
                  floatingLabelStyle={{color: '#'+this.props.secondaryColor}}
                  floatingLabelFocusStyle={{color: '#'+this.props.secondaryColor,}}
                  underlineStyle={{borderColor: BODY_TEXT_COLOR, }}
                  underlineFocusStyle={{ borderColor: '#'+this.props.secondaryColor}}
                />
                }
            </div>
            <div>
              <RaisedButton
                onClick={this.handleNextClick}
                backgroundColor={`#` + this.props.secondaryColor}
                labelColor="#FFF"
                label="Next"
                labelStyle={this.styles.labelStyle}
              />
            </div>
          </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tempUser: state.user.tempUser,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    reasons: getReasonsSelector(state),
    isEmailVerification: isEmailVerificationRequired(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return { 
    openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
    setUser: (user) => dispatch(userReducer.setUser(user)),
    hideModal: () => dispatch(modal.hideModal()),
    openSignUpConfirm: (props) => dispatch(modal.openModal({
      modalType: 'SIGNUP_CONFIRM_FORM',
      modalProps: {}
    })),
    requestCode: () => dispatch(startRequestCode()),
    howDidYouHear: (string) => dispatch(howDidYouHear(string))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HowDidYouHearModal);

const HeaderDiv = styled.div `
  color: ${props => props.color};
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  text-align: center;
  max-width: 275px;
`;


// WEBPACK FOOTER //
// ./src/components/HowDidYouHearModal/HowDidYouHearModal.jsx